import { useContext, useEffect, useMemo, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import businessApi, { TypesLibro } from '../api/business.api'
import GlobalContext from '../context/global-context'

const resolveLibroType = (pathname: string, search: string): TypesLibro | null => {
  const tab = new URLSearchParams(search).get('tab')

  if (pathname.toLowerCase() === '/administracion') {
    if (!tab || tab === 'clientes') return TypesLibro.VENTA
    if (tab === 'proveedores') return TypesLibro.COMPRA
    if (tab === 'vinculaciones') return TypesLibro.MANUAL
  }

  if (
    (pathname === '/' || pathname.toLowerCase() === '/businessinsights') &&
    tab === 'proyeccion-f29'
  ) {
    return TypesLibro.DOC29
  }

  return null
}

const FirstLastNavigationTracker = () => {
  const { pathname, search } = useLocation()
  const { currentBusiness, setFirstLast } = useContext(GlobalContext)
  const lastRequestKey = useRef<string | null>(null)
  const type = useMemo(() => resolveLibroType(pathname, search), [pathname, search])

  useEffect(() => {
    const businessId = currentBusiness?.id

    if (!businessId || !type) {
      lastRequestKey.current = null
      setFirstLast({ data: null, type: null, isLoading: false, error: null })
      return
    }

    const requestKey = `${businessId}:${type}`
    if (lastRequestKey.current === requestKey) return
    lastRequestKey.current = requestKey

    let isCurrentRequest = true
    setFirstLast(previous => ({ ...previous, type, isLoading: true, error: null }))

    businessApi
      .getFirstLast(businessId, type)
      .then(response => {
        if (!isCurrentRequest) return
        console.log('[first-last] respuesta', { businessId, type, data: response.data })
        setFirstLast({ data: response.data, type, isLoading: false, error: null })
      })
      .catch(error => {
        if (!isCurrentRequest) return
        console.error('[first-last] error', { businessId, type, error })
        setFirstLast({ data: null, type, isLoading: false, error })
      })

    return () => {
      isCurrentRequest = false
    }
  }, [currentBusiness?.id, setFirstLast, type])

  return null
}

export default FirstLastNavigationTracker
